/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Remote_Desc6Inputs */

const en_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployed MCP server with streaming transport, reachable from any client.`)
};

const ar_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خادم MCP منشور مع ستريمينغ، يمكن الوصول إليه من أي عميل.`)
};

const bn_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্রিমিং পরিবহনসহ ডিপ্লয় করা MCP সার্ভার, যেকোনো ক্লায়েন্ট থেকে পৌঁছানো যায়।`)
};

const de_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitgestellter MCP-Server mit Streaming-Transport, erreichbar von jedem Client.`)
};

const es_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servidor MCP desplegado con transporte de streaming, accesible desde cualquier cliente.`)
};

const fr_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serveur MCP déployé avec transport streaming, joignable depuis n'importe quel client.`)
};

const pt_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servidor MCP publicado com transporte de streaming, acessível de qualquer cliente.`)
};

const zh_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部署好的 MCP 服务器，流式传输，任何客户端都能连。`)
};

const tr_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akışlı taşımalı yayındaki MCP sunucusu, her istemciden erişilebilir.`)
};

const ru_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задеплоенный MCP-сервер со стриминговым транспортом, доступен из любого клиента.`)
};

const pl_svc_mcp_server_development_remote_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożony serwer MCP z transportem strumieniowym, osiągalny z każdego klienta.`)
};

/**
* | output |
* | --- |
* | "Deployed MCP server with streaming transport, reachable from any client." |
*
* @param {Svc_Mcp_Server_Development_Remote_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_remote_desc6 = /** @type {((inputs?: Svc_Mcp_Server_Development_Remote_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Remote_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "de") return de_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "es") return es_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_remote_desc6(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_remote_desc6(inputs)
	return en_svc_mcp_server_development_remote_desc6(inputs)
});
export { svc_mcp_server_development_remote_desc6 as "svc_mcp-server-development_REMOTE_desc" }